var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIRipple',{staticClass:"x-menu-icon",class:{ circle: _vm.circle },attrs:{"color":"black","opacity":0.15,"speed":3}},[_c('UIIcon',{attrs:{"name":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }